"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondary = exports.primary = void 0;

var _swatches = require("../swatches");

var primary = {
  brand: _swatches.brand['500'],
  positive: _swatches.positive['500'],
  warning: _swatches.warning['500'],
  warningText: _swatches.warning['900'],
  negative: _swatches.negative['500'],
  negativeAlt: _swatches.negativeAlt['500']
};
exports.primary = primary;
var secondary = {
  brand: _swatches.brand['50'],
  positive: _swatches.positive['50'],
  warning: _swatches.warningExtra.light,
  negative: _swatches.negativeExtra.light,
  negativeAlt: _swatches.negativeAlt['50']
};
exports.secondary = secondary;
//# sourceMappingURL=base.js.map